// src/extenders/search-switcher.js
var SearchSwitcher = class extends HTMLElement {
  constructor() {
    super();
    const searchButtons = this.querySelectorAll(".js-search-switch-button");
    searchButtons.forEach((searchButton) => {
      if (searchButton.classList.contains("js-active")) {
        const dataSearchType = searchButton.getAttribute("data-search-type");
        const dataSearchContainer = this.querySelector(`.js-search-container[data-search-container="${dataSearchType}"]`);
        dataSearchContainer.classList.remove("hidden");
        dataSearchContainer.classList.add("flex");
        dataSearchContainer.classList.add("lg:grid");
      }
      searchButton.addEventListener("click", () => {
        searchButtons.forEach((button) => {
          button.classList.remove("js-active");
        });
        searchButton.classList.add("js-active");
        document.querySelectorAll(".js-search-container").forEach((container) => {
          container.classList.add("hidden");
          container.classList.remove("flex", "lg:grid");
        });
        const dataSearchType = searchButton.getAttribute("data-search-type");
        const dataSearchContainer = this.querySelector(`.js-search-container[data-search-container="${dataSearchType}"]`);
        dataSearchContainer.classList.remove("hidden");
        dataSearchContainer.classList.add("flex");
        dataSearchContainer.classList.add("lg:grid");
      });
    });
  }
};
if (customElements.get("search-switcher") === void 0) {
  customElements.define("search-switcher", SearchSwitcher);
}
